import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCarbonFootprint } from '../../context/CarbonFootprintContext';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Lottie from 'lottie-react';

const EmployeeNoScreen = () => {
    const navigate = useNavigate();
    const { updateCarbonData } = useCarbonFootprint();
    const [selectedOption, setSelectedOption] = useState('');
    const [windyAnimation, setWindyAnimation] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init();
        // Load animation dynamically
        fetch('/assets/animations/Weather-windy.json')
            .then(res => res.json())
            .then(data => setWindyAnimation(data))
            .catch(err => console.log('Animation load error:', err));
    }, []);

    const options = [
        { label: '1 - 100', value: 50 },
        { label: '101 - 500', value: 300 },
        { label: '501 - 1000', value: 800 },
        { label: '1001 - 5000', value: 3000 },
        { label: '5001 - 10000', value: 8000 },
        { label: '10000+', value: 10000 },
    ];

    const handleContinue = () => {
        if (!selectedOption) {
            alert('Please select the number of employees before continuing.');
            return;
        }
        updateCarbonData('numOfEmployees', Number(selectedOption));
        navigate('/CCF-Calculator/revenue');
    };

    return (
        <div className="ccf-business-screen-container">
            {windyAnimation && (
                <div className="ccf-business-background-animation">
                    <Lottie
                        animationData={windyAnimation}
                        loop
                        autoplay
                        style={{
                            width: 400,
                            height: 200,
                            opacity: 1
                        }}
                    />
                </div>
            )}
            <div className="ccf-business-content-container">
                <h2 className="ccf-business-question-text" data-aos="fade-up" data-aos-duration="800">
                    How many employees does your organization have?
                </h2>
                <div className="ccf-business-radio-group" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={`ccf-business-radio-box ${selectedOption === String(option.value) ? 'ccf-business-radio-box-selected' : ''}`}
                            onClick={() => setSelectedOption(String(option.value))}
                        >
                            <input
                                type="radio"
                                name="employeeNo"
                                value={option.value}
                                checked={selectedOption === String(option.value)}
                                onChange={() => setSelectedOption(String(option.value))}
                                className="ccf-business-radio-input"
                            />
                            <label className="ccf-business-radio-label">{option.label}</label>
                        </div>
                    ))}
                </div>
                <div className="ccf-business-button-container" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
                    <button className="ccf-business-continue-btn" onClick={handleContinue}>
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EmployeeNoScreen;
